import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { Response } from 'services/api/types'

type AutentiqueLink = {
  link: string
}

const updateOrderDeliveryDate = (data: any): Response<AutentiqueLink> => {
  return axios.put(`/orders/proposals/${data.proposalId}/delivery-date`, data)
}

export function useUpdateOrderDeliveryDate() {
  const queryClient = useQueryClient()
  return useMutation(updateOrderDeliveryDate, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('proposal')
      queryClient.invalidateQueries('orderActions')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível atualizar a data de entrega!')
    }
  })
}
